// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SecurityScanFilledSvg from "@fishx/icons-svg/es/asn/SecurityScanFilled";
import FishxIcon from '../components/FishxIcon';

var SecurityScanFilled = function SecurityScanFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanFilledSvg
  }));
};

SecurityScanFilled.displayName = 'SecurityScanFilled';
export default React.forwardRef(SecurityScanFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SecurityScanFilled.js
// module id = 4080
// module chunks = 0